import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { ToolService, ParallelProcessService, ToolTypeService } from '../../../camtl.service';
import { Tool } from '../../../../../shared/model';
import { CgpTreeviewService } from '../../../../../shared/cgp-treeview/cgp-treeview.service';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpConfirmationDialogService } from '../../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'cells',
  templateUrl: './cells.component.html',
  // styleUrls: ['./cells.component.scss']
})
export class CellsComponent implements OnInit, OnDestroy {

  constructor(
    private service: ToolService,
    private toolTypeService: ToolTypeService,
    private formBuilder: FormBuilder,
    private systemSelectService: SystemSelectService,
    private routeParams: ActivatedRoute,
    private parallelProcessService: ParallelProcessService,
    private cgpTreeviewService: CgpTreeviewService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private cgpConfirmationDialogService: CgpConfirmationDialogService,
    private routeValidationService: RouteValidationService
  ) { }

  systemLayout: string;
  editForm: FormGroup;
  editDataItem: Tool;
  system: any;
  cellId: string;
  systemLayoutId: string;
  toolTypeId: string = undefined;
  dataSource: any;
  selected: any;
  selectedRowId: any;
  selectedCellNumber: string;
  showAssignWindow: any;
  parentId: any;
  disableActions: boolean = false;
  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent
  private ngUnsubscribe: Subject<void> = new Subject<void>();


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  ngOnInit() {
    var self = this;

    this.editForm = this.formBuilder.group({
      Id: [],
      CellParallelProcessId: [""],
      CreatedBy: [],
      CreatedDate: [],
      SystemId: [""],
      Stations: [],
      Components: [],
      Tools: [],
      CellNumber: [],
      ToolTypeId: [],
      ParentId: [],
      JobNumber: [],
      ToolDescriptionId: []
    })

    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Cells')) {
          this.cgpTreeviewService.dataSource$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(dataSource => this.dataSource = dataSource);
          this.cgpTreeviewService.selected$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(selected => this.selected = selected);
          this.cgpTreeviewService.get();
          this.cgpTreeviewService.getSelected();
        }
        if (this.system && this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
          this.disableActions = true;
          this.template.controls.add = false;
          this.template.controls.edit = false;
          this.template.controls.delete = false;
        }
        else {
          this.disableActions = false;
          this.template.controls.add = true;
          this.template.controls.edit = true;
          this.template.controls.delete = true;
        }
      });
    this.systemSelectService.get();
    this.parallelProcessService.query();

    this.routeParams.queryParams
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: Params) => {
        this.parentId = params["ParentId"];
        if (this.parentId && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Cells') && this.parentId.includes('-')) {
          this.service.read("/" + this.parentId, true)
            .then(function (response) {
              self.systemLayout = response[0].ToolDetail.ToolNumber;
            })
        }

      })

    this.routeParams.params
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        if (this.routeParams.snapshot.params["id"]) {
          this.cellId = this.routeParams.snapshot.params["id"];
        }
        else {
          this.cellId = "";
        }
      });

    this.changeTemplateService();
  }

  ngOnChanges() {
    if (this.routeParams.snapshot.params["id"]) {
      this.cellId = this.routeParams.snapshot.params["id"];
    }
  }

  columns: any[] = [
    {
      field: "CellNumber",
      title: "Cell Number",
    },
    {
      field: "CellParallelProcessName",
      title: "Parallel Process"
    }
  ];


  formDialog = {
    title: "Cell",
    formControls: [
      {
        type: 'text',
        name: 'CellNumber',
        title: 'Cell Number'
      },
      {
        type: 'combobox',
        name: 'CellParallelProcessId',
        title: 'Parallel Process',
        textField: 'Name',
        valueField: 'Id',
        placeholder: 'Select Parallel Process...',
        service: this.parallelProcessService
      },
    ]
  }

  assignToolsToCell = (e, dataItem) => {
    this.selectedRowId = dataItem.Id;
    this.selectedCellNumber = dataItem.CellNumber;
    this.showAssignWindow = true;
  }

  saveToolAssignment(dataItems) {
    var self = this;
    for (var i = 0; i < dataItems.length; i++) {
      this.service.save(dataItems[i], false).then(function () {
        if (i === dataItems.length) {
          self.showAssignWindow = false;
          self.cgpTreeviewService.refresh();
          self.cgpTreeviewService.get();
          self.cgpSnackbarService.showSnackbar({
            message: i === 1 ? "Tool has been assigned" : "Tools have been assigned",
            duration: 2000
          });
          self.systemSelectService.get();
        }
      });
    }
  }

  cancelToolAssignment() {
    this.showAssignWindow = false;
    this.selectedRowId = undefined;
  }

  setCellNumber = (e, dataItem) => {
    var self = this;
    this.cgpConfirmationDialogService.showConfirmationDialog({
      title: 'Set Cell Number',
      message: 'Are you sure that you want to set the number for this cell?',
      alert: 'danger',
      onYesClick: () => {
        self.service.save(dataItem, false, "/cellnumber/" + dataItem.Id, false, false).then(function () {
          self.cgpSnackbarService.showSnackbar({
            message: 'Cell number has been set',
            duration: 2000
          });
          self.grid.refresh(true);
          self.cgpConfirmationDialogService.closeConfirmationDialog();
        }).catch(function (response) {
          self.service.loading.next(false);;
          self.cgpAlertDialogService.showAlertDialog({
            title: 'Error',
            message: response._body.replace(/"/g, ''),
            alert: 'danger',
            closeLabel: 'Close',
          })
          self.cgpConfirmationDialogService.closeConfirmationDialog();
        });
      },
      onNoClick: () => {
        this.cgpConfirmationDialogService.closeConfirmationDialog();
      }
    })
  }

  customButtons = [
    {
      id: "assignToolsToCell",
      class: "fa fa-wrench",
      title: "Assign Tool(s)",
      callback: this.assignToolsToCell
    },
    {
      id: 'setCellNumber',
      class: "fa fa-tag",
      title: "Set Cell Number",
      callback: this.setCellNumber
    }
  ];

  isDisabled = (id) => {
    switch (id) {
      case "assignToolsToCell":
      case "setCellNumber":
        return this.disableActions;
      case "add":
        if (!this.toolTypeId) {
          return true;
        }
        else {
          return false;
        }
      default:
        return false;
    }
  }

  getById = () => {
    var self = this;
    if (this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Cells')) {
      this.toolTypeService.read()
        .then(function (response: any) {
          self.toolTypeId = response.filter(function (item) {
            return item.Description.toUpperCase() === "CELL";
          })[0].Id;

        })
      return this.service.read("/" + this.cellId, true);
    }
  }

  changeTemplateService() {
    if (this.cellId) {
      this.template = {
        controls: {
          add: false,
          edit: true,
          delete: true,
          excel: true,
          width: 190,
          custom: this.customButtons,
          isDisabled: this.isDisabled
        },
        columns: this.columns,
        service: this.service,
        read: this.getById,
        fileName: "cells.xlsx",
        displayField: "CellNumber"
      }
    }
  }

  getCellsByParentId = () => {
    var self = this;
    if (this.parentId && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Detail/Cells') && this.parentId.includes('-')) {
      this.toolTypeService.read()
        .then(function (response: any) {
          self.toolTypeId = response.filter(function (item) {
            return item.Description.toUpperCase() === "CELL";
          })[0].Id;

        })
      return this.service.read("/cells/" + this.parentId, true);
    }
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
      width: 190,
      custom: this.customButtons,
      isDisabled: this.isDisabled
    },
    columns: this.columns,
    service: this.service,
    read: this.getCellsByParentId,
    fileName: "cells.xlsx",
    displayField: "CellNumber"
  }

  setModelHandler() {
    this.editDataItem = new Tool();
    this.editDataItem.ToolTypeId = this.toolTypeId;
    this.editDataItem.ParentId = this.parentId;
    this.editDataItem.MakeFurnish = "M";
    this.editDataItem.JobNumber = 0;

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }

}
